import React from 'react';
import classnames from 'classnames';

import './index.scss';

import SvgIcon from '@/pages/home/components/SvgIcon';

import type { IBaseProps } from '@/pages/intelligence/types/common';

interface IStoreRanksNumtrendProps extends IBaseProps {
  num: number;
}

const StoreRanksNumtrend: React.FC<IStoreRanksNumtrendProps> = (props) => {
  const { num } = props;
  const numTmp = Number.parseInt(num as any, 10);
  const isNumTmpNaN = Number.isNaN(numTmp);
  const absNumTmp = Math.abs(numTmp);
  const numTextTmp = absNumTmp > 999 ? `999+` : absNumTmp;

  return (
    <div className="dbi-storeranks-numtrend">
      {/* 无效数据 展示- */}
      {isNumTmpNaN && <span className="dbi-storeranks-numtrend-text">-</span>}
      {/* 0 展示= */}
      {numTmp === 0 && <span className="dbi-storeranks-numtrend-text">=</span>}
      {/* 非无效数据，并且不为0 */}
      {!isNumTmpNaN && numTmp !== 0 && (
        <div className="dbi-storeranks-numtrend-cont">
          <span
            className={classnames({
              'dbi-storeranks-numtrend-green': numTmp > 0,
              'dbi-storeranks-numtrend-red': numTmp < 0,
            })}
          >
            {numTextTmp}
          </span>
          <SvgIcon className="dbi-storeranks-numtrend-icon" type={numTmp > 0 ? 'green-up-new' : 'red-down-new'} />
        </div>
      )}
    </div>
  );
};

export default StoreRanksNumtrend;

/**
 * 以下为重构搞源代码
 */

// import React, { useState } from 'react';

// import './index.scss';

// import SvgIcon from '@/pages/home/components/SvgIcon';

// export default function StoreRanksNumtrend(props: any) {
//   const { num } = props;

//   return (
//     <div className='dbi-storeranks-numtrend'>
//       {
//         num == 0 ? <span className='dbi-storeranks-numtrend-text'>-</span> : <div className='dbi-storeranks-numtrend-cont'>
//           <span className={num > 0 ? 'dbi-storeranks-numtrend-green' : 'dbi-storeranks-numtrend-red'}>{num}</span>
//           <SvgIcon
//             type={num > 0 ? 'green-up-new' : 'red-down-new'}
//             className="dbi-storeranks-numtrend-icon"
//           />
//         </div>
//       }
//     </div>
//   )
// }
